import { KeyboardDoubleArrowDownOutlined, MoreHoriz } from "@mui/icons-material"
import { Button, Card, CardMedia, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, ImageListItemBar, Typography } from "@mui/material"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { send_email_emailJs } from "../../../actions/shared_actions"
import { EnquireDialog } from "./packages"

import { FadeInSection } from "./home_window"


export const LargeCards = ({title, info}) =>{

    return (
        <div className='large_card_paper'>
                <div class="large_card  title_back" raised={true}>
                    <div className='centered_titles centered_titles_title'>
                        <h1 variant="h2">{title}</h1>
                    </div>
                </div>
                <div class="large_card" >
                    <div className='centered_titles'>
                        <Typography>{info}</Typography>
                    </div>
                </div>
        </div>
    )
}
export const LargeCardsFlip = ({title, info}) =>{

    return (
        <div className='large_card_paper'>
            <div class="large_card" >
                <div className='centered_titles'>
                    <Typography>{info}</Typography>
                </div>
            </div>
            <div class="large_card  title_back" raised={true}>
                <div className='centered_titles centered_titles_title'>
                    <h1 variant="h2">{title}</h1>
                </div>
            </div>
        </div>
    )
}


export const LargeCardHor = ({ title, info=[]}) => {

    return (
        <div style={{width:'100%', height:'max-content', display:'flex', flexDirection:'column', backGroundColor:''}}>
            <div class='wider_end_services'>
                <Typography variant="h6">{title}</Typography>
            </div>
            <div class="">
                <Typography>{info}</Typography>
            </div>
        </div>
    )
}


export const ServicesSection = ({services=[]}) => {
    const [hovered, set_hovered] = useState(false)
    const [selected, set_selected] = useState({id:1, title:"", description:''})

    const [more_services, set_more_services] = useState(3)

    return (
        <div style={{width:'100%', height:'max-content', display:'flex', flexDirection:'column'}}>
            <Card class='wider_end_services'>
                    <h4>{'SERVICES'}</h4>
            </Card>
            <div className="paper">

            <Grid className={"mainContainer"} container alignItems="stretch" spacing={3}>
                {services.map(s=> <Grid item key={s.id} xs={11} sm={6} lg={4}>
                    <FadeInSection>
                        <Card className={"card"} >
                            <CardMedia className={"media"} image={s.cover_image} title={s.title}/>
                            
                            <div className={"overlay"}>
                                <Typography variant={'h6'}>{s.title}</Typography>
                            </div>
                            <ImageListItemBar
                                title={s.description} 
                                actionIcon={
                                    <div>
                                        <IconButton onClick={e=>{
                                            set_selected(s)
                                            set_hovered(true)}}>
                                            <MoreHoriz color="warning" />
                                        </IconButton>
                                    </div>
                                }
                                />
                        </Card>
                    </FadeInSection>
                    <ServicesPopUp s={selected} open={hovered} handleClose={e=>set_hovered(false)} />
                    </Grid>).slice(0, more_services)}
                </Grid>
            <IconButton onClick={e=>set_more_services(more_services+3)} >{<KeyboardDoubleArrowDownOutlined />}</IconButton>
            </div>

        </div>
    )
}


const ServicesPopUp = ({s, open, handleClose}) => {
    const dispatch = useDispatch()

    const [open_query, set_open_query] = useState(false)
    
    const handleSubmit = (e, inquiry) => {
        inquiry = {...inquiry, message:inquiry.message + `; PACKAGE: ${s.title}; ID: ${s.id}`}
        e.preventDefault()
        dispatch(send_email_emailJs(inquiry))
        set_open_query(false)
    }

    return (
             <Dialog open={open} onClose={handleClose}>
                <CardMedia className={"media"} image={s.cover_image} title={s.title}/>
                <DialogTitle>{s.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {s.description}
                    </DialogContentText>
                    <DialogContentText>
                    </DialogContentText>
                </DialogContent>
                <EnquireDialog pack={s} open={open_query} handleClose={()=>set_open_query(false)} handleSubmit={handleSubmit} />
                <DialogActions>
                    <Button onClick={e=>handleClose()}>Back</Button>
                    <Button color="warning" onClick={e=>{
                        e.preventDefault()
                        set_open_query(true)}}>Enquire</Button>
                </DialogActions>
	        </Dialog>
    )
}


export const LandingElements = () => {

    return (
        <div style={{color:"blue", fontSize:40, fontWeight:700, width:'100%'}}>
            <div style={{display:'grid', gridTemplateColumns:"1fr 1fr"}}>
                <h1 >Experience a travel like no other</h1>
            </div>
        </div>
    )
}




